import React from 'react';

import { IconProps } from './types';

const PlusIcon: React.FC<IconProps> = props => {
  const { fillColor = '#585757' } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_521_3017" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_521_3017)">
        <path d="M11 19V13H5V11H11V5H13V11H19V13H13V19H11Z" fill={fillColor} />
      </g>
    </svg>
  );
};

export default PlusIcon;
